import axios from 'axios'

const API_URL = process.env.VUE_APP_API_BASE_URL

class SubscriberService {
  subscribeWithEmail(emailObj) {
    return axios.post(API_URL + '/EmailSubscriber/create', emailObj)
  }
}

export default new SubscriberService()